export const isServerError = (statusCode?: number) => {
  if (!statusCode) {
    return false
  }

  switch (statusCode) {
    case 500:
    case 502:
    case 503:
    case 504:
      return true

    case 401:
    case 403:
    case 404:
    case 422:
      return false

    default:
      return false
  }
}
